import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { TicketSyncPage } from "@/components/data-sources/ticket-sync-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/data-sync/tickets",
  loader: async () => {
    const [settingsRes, historyRes, countRes] = await Promise.all([
      fetch("/api/settings/ticket-sync"),
      fetch("/api/tickets/sync-history"),
      fetch("/api/tickets/count"),
    ]);
    const settings = settingsRes.ok ? await settingsRes.json() : null;
    const history = historyRes.ok ? await historyRes.json() : { results: [] };
    const countData = countRes.ok ? await countRes.json() : { total: 0 };
    return {
      ticketSyncSettings: settings ?? {
        intervalMs: 3600000,
        lastSyncedAt: null,
        backfillCompletedAt: null,
        schedulerActive: false,
      },
      ticketSyncHistory: history.results ?? [],
      totalLocalTickets: countData.total ?? 0,
    };
  },
  component: TicketSyncPageGuard,
});

function TicketSyncPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  // biome-ignore lint/suspicious/noExplicitAny: role is added by the admin plugin at runtime
  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <TicketSyncPage />;
}
